import { CHAINS_DICT } from '@/utils/chain';
export const transformGroup = (group: Group) => {
  const tokenName = group.token?.optimized_symbol || group.collection?.name || '';
  const chainName = CHAINS_DICT[group.chain_id]?.name || '';

  group._assetName = `${tokenName}${chainName ? '(' + chainName + ')' : ''}`;

  group._relatedAsset = `${group.market_opinion === 'bullish' ? 'Bullish' : 'Bearish'} on ${
    group._assetName
  }`;

  return group;
};
